<!-- 認証失敗 -->
<template>
  <ItemDialog ref="DialogValidFramesWithQRFails" image-type="alert">
    <template #content-area>
      <h2>
        {{ $t("MyTicketTicketing.QRFailed.title") }}
      </h2>
      <p class="text-center">
        {{ $t("MyTicketTicketing.QRFailed.description") }}
      </p>
    </template>
    <template #button-area>
      <ItemButton
        :label="$t('MyTicketTicketing.QRFailed.buttonLabel1')"
        action-type="btn-primary"
        @clicked="goToEmergencyCode"
      />
    </template>
  </ItemDialog>
  <!-- 認証失敗 -->
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "DialogValidFramesWithQRFails",
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const DialogValidFramesWithQRFails = ref(null);
    const frame = store.getters["ticketing/frame"];

    const openDialog = () => {
      DialogValidFramesWithQRFails.value.open();
    };

    const closeDialog = () => {
      DialogValidFramesWithQRFails.value.close();
    };

    const goToEmergencyCode = () => {
      // 複数枚の場合と1枚の場合で代入
      var sheetID = route.params.sheet_id.match(/,/)
        ? route.params.sheet_id.split(",")[0]
        : route.params.sheet_id;
      // TODO 修正 ボタンで戻れない
      router.push({
        name: "SheetEmergencyCode",
        params: {
          book_group_id: route.params.book_group_id,
          sheet_id: sheetID,
          frame_id: String(frame.id),
        },
        query: {
          language: store.getters["common/lang"],
          qrFailed: true,
        },
      });
    };

    return {
      DialogValidFramesWithQRFails,
      openDialog,
      closeDialog,
      goToEmergencyCode,
    };
  },
};
</script>
